import React from 'react';
import { Button, Modal, Icon, Row, Table, Avatar, Spin, Col, Tooltip } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import MultiplyItemsColumnRender from '../../common/Table/MultiplyItemsColumnRender';
import styles from './../styles.less';
import { PencilIcon, TrashIcon } from '../../Icons';
import { getAvatarUrl } from '../../../utils/avatar';

class UsersAdministration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: 0,
      filter: {
        search: '**',
      },
      isAdministrationUsers: window.location.href.includes('administration/users'),
      labelPreset: window.location.href.includes('administration/users') ? 'Administration.User' : 'User',
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: `Component.${this.state.labelPreset}.Administration.Title`,
        description: `Component.${this.state.labelPreset}.Administration.Description`,
      },
    });
    this.props.dispatch({ type: 'app/showNotifications' });
  }

  getData(psf) {
    const user = this.props.app.user;
    const client_id = user.client_id ? user.client_id : this.state.isAdministrationUsers ? '[null]' : this.props.app.selectedClient.id;
    const filter = { email: this.state.filter.search, client_id };
    const params = psf.page ? psf : { sorting: psf.sorting, page: '1' };
    const payload = { filter, ...params };

    if (filter.email !== '**') {
      payload.filtered = true;
    }

    return this.props.dispatch({ type: 'users/loadList', payload });
  }

  remove(id) {
    this.props.dispatch({
      type: 'users/remove',
      payload: { id },
    }).then(() => {
      this.props.dispatch({ type: 'app/showNotifications' });
      this.setState({ removedId: id });
    });
  }

  showDeleteConfirm = (record) => {
    const { first_name, last_name } = record;
    const self = this;
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: `Component.${this.state.labelPreset}.Administration.Modal.Description` }, {
          first_name,
          last_name,
        }),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk() {
        self.remove(record.id);
      },
    });
  }

  render() {
    const { Column } = Table;

    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent self={this} fieldPlaceholder={this.props.intl.formatMessage({ id: `Component.${this.state.labelPreset}.Administration.SearchByEmailPlaceholder` })} />
              <Col span={14} className="text-right">
                <Button
                  size="large"
                  type="primary"
                  onClick={() => this.props.dispatch({ type: 'app/goToRoute', payload: { routeName: this.state.isAdministrationUsers ? 'ADMINISTRATION_USER_NEW' : 'USER_NEW' } })}
                >
                  <Icon type="plus" />
                  <FormattedMessage id={`Component.${this.state.labelPreset}.Administration.Create`} />
                </Button>
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={this.props.loading.models.users}>
          <AjaxTable
            updateKey={JSON.stringify([this.state.removedId, this.state.filter])}
            getData={this.getData.bind(this)}
            rowKey="id"
            className={styles.userList}
          >
            <Column
              title=""
              key="userAvatar"
              render={data => (
                <div data-label=" ">
                  {data.avatar ?
                    <Avatar
                      size="large"
                      icon="user"
                      src={`${getAvatarUrl(this.state.isAdministrationUsers ? null : this.props.app.defaultUiSettings.core_client_id, data.avatar)}`}
                    /> :
                    <Avatar size="large" icon="user" />
                  }
                </div>
              )}
              width={80}
              fixed="left"
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Email' })}
              key="email"
              dataIndex="email"
              sorter
              className={styles.tableColumnWrap}
              render={data => <div data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Email' })}>{data}</div>}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.LastName' })}
              key="last_name"
              dataIndex="last_name"
              sorter
              className={styles.tableColumnWrap}
              render={data => <div data-label={this.props.intl.formatMessage({ id: 'Grid.Column.LastName' })}>{data}</div>}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.FirstName' })}
              key="first_name"
              dataIndex="first_name"
              sorter
              className={styles.tableColumnWrap}
              render={data => <div data-label={this.props.intl.formatMessage({ id: 'Grid.Column.FirstName' })}>{data}</div>}
            />
            {!this.state.isAdministrationUsers && (
              <Column
                title={this.props.intl.formatMessage({ id: 'Grid.Column.Accounts' })}
                key="accounts"
                dataIndex="projects"
                className={styles.tableColumnWrap}
                render={projects => (
                  <div
                    data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Accounts' })}
                  >
                    {projects && projects.length ?
                      <div className="cell-popover">
                        <MultiplyItemsColumnRender itemList={projects.map(i => i.name)} />
                      </div>
                      : <FormattedMessage id="Common.NoData" />
                    }
                  </div>
                )}
              />
            )}
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(
  ({ app, users, loading }) => ({ app, users, loading }))(injectIntl(UsersAdministration));



// WEBPACK FOOTER //
// ./src/components/UsersAdministration/UsersList/UsersList.js